<template>
    <div id="wrapper">
      <Sidebar></Sidebar>
      <!-- Content Wrapper -->
      <div id="content-wrapper" class="d-flex flex-column">

        <!-- Main Content -->
        <div id="content">

          <Topbar></Topbar>

          <!-- Begin Page Content -->
          <div class="container-fluid">

            <!-- Page Heading -->
            <router-link :to="{ name: 'Home'}" > CRCB Control Panel</router-link> > 
            <router-link :to="{ name: 'Faculty'}" > 中心成員管理</router-link> > 
            <span>中心成員{{mode}}</span>

            <h1 class="h3 mb-2 mt-2 text-gray-800">中心成員{{mode}}</h1>
            
            <Msg :message="message" :is_error="is_error"></Msg>

            <!-- DataTales Example -->
            <div class="card shadow mb-4">
              <div class="card-header py-3">
                <button type="button" class="btn btn-primary" v-on:click="Post" v-if="!is_edit ">新增</button>
                <button type="button" class="btn btn-primary" v-on:click="Update" v-if="is_edit ">儲存</button>
                <button type="button" class="btn btn-danger" v-on:click="Delete" data-bs-toggle="tooltip" data-bs-placement="top" v-if="is_edit">刪除</button>
              </div>
              <div class="card-body">
                <form>
                    <div class="form-group">
                        <label for="center_role"><span>*</span>中心角色</label>
                        <input type="email" class="form-control form-control-user" id="center_role"  v-model="data.center_role" >
                        <InputMsg ref="child" :title="'中心角色'" :value="data.center_role" @verify="checkVerify"></InputMsg>
                    </div>
                    <div class="form-group">
                        <label for="name">姓名</label>
                        <input type="text" class="form-control form-control-user" id="name"  v-model="data.name"  >
                    </div>
                    <div class="form-group">
                        <label for="job_title">職稱</label>
                        <input type="text" class="form-control form-control-user" id="job_title"  v-model="data.job_title" >
                    </div>
                    <UploadFile :name="name" :id="id" :title="title" :src="data.src" :height="data.height" :width="data.width" @update="selfUpdate"></UploadFile>
                    <div class="form-group">
                        <label for="experience">經歷</label>
                        <vue-editor v-model="data.experience" id="experience" rows="3"  :editorOptions="editorOptions" />
                    </div>
                    <div class="form-group">
                        <label for="education">學歷</label>
                        <textarea class="form-control" id="education" rows="3" v-model="data.education" ></textarea>
                    </div>
                    <div class="form-group">
                        <label for="expertise">專長</label>
                        <textarea class="form-control" id="expertise" rows="3" v-model="data.expertise" ></textarea>
                    </div>
                    <div class="form-group">
                        <label for="phone">電話</label>
                        <input type="text" class="form-control form-control-user" id="phone"  v-model="data.phone" >
                    </div>
                    <div class="form-group">
                        <label for="email">E-mail</label>
                        <input type="text" class="form-control form-control-user" id="email"  v-model="data.email" >
                    </div>
                </form>
              </div>
            </div>

          </div>
          <!-- /.container-fluid -->

        </div>
        <!-- End of Main Content -->

        <Footer></Footer>

      </div>
      <!-- End of Content Wrapper -->
    </div>
</template>

<script>
import {fb, db } from '../firebase'
export default {
  name: 'FacultyInfo',
  data () {
    return {
      id:this.$route.params.id || db.collection("faculty").doc().id,
      mode:'',
      is_edit:false,
      title:'成員照片',
      name:'faculty',
      data:{
        center_role:'',
        name:'',
        job_title:'',
        experience:'',
        education:'',
        expertise:'',
        phone:'',
        email:'',
        src:'',
        pic_name:'',
        height:'',
        width:'',
        order:0
      },
      is_upload:true,
      uploadValue:100,
      message:'',
      is_error:false,
      editorOptions: {
        modules: {
          toolbar: false
        }
      },
      verify:true
    }
  },
  mounted () {
    this.Switch();
    this.GetOrder();
  },
  methods: {
    Switch() {
      if ( this.$route.name == 'FacultyAdd'  ) {
          this.mode = '新增';
      } else {
          this.mode = '編輯';
          this.is_edit = true;
      }
    },
    Get(){
      if ( this.$route.name != 'FacultyAdd'  ) {
        db.collection("faculty").doc(this.id).get().then((doc) => {
            if (doc.exists) {
              this.data = doc.data();
              console.log(this.data)
            } else {
              this.$router.push({name: 'Faculty'});
            }
        }).catch((error) => {
            console.log("Error getting document:", error);
        });
      }
    },
    GetOrder(){
      var vm = this;
      var array = [];
      db.collection("faculty").get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          var data = {"id": doc.id, "data": doc.data()};
            
            array.push(data);
        });
        array.sort( (d1, d2) => d2.data.order - d1.data.order);
        
        if ( array.length != 0 ) this.data.order = array[0].data.order +1;

        vm.Get()

      });  
       
    },
    Auth() {

      this.$refs.child.check();
      
      if ( this.verify ) return true;
      else return false;
    },
    Post() {
     
      if ( this.Auth() ) {
        this.Beforesend();
        db.collection("faculty").doc(this.id).set(this.data)
        .then((doc) => {
            alert("成功!");
            this.$router.push({name: 'Faculty'});
            this.Aftersend();
        }).catch((error) => {
            console.log("Error getting document:", error);
            this.Aftersend();
        });
      }
    },
    Update() {

      if ( this.Auth() ) {
        this.Beforesend();
        db.collection("faculty").doc(this.id).update(this.data)
          .then(() => {
              alert("成功!");
              this.$router.push({name: 'Faculty'});
              this.Aftersend();
          }).catch((error) => {
              console.log("Error getting document:", error);
              this.Aftersend();
          });
       }
    
    },
    Delete() {
      if ( confirm("確定要刪除?") ) {
        db.collection("faculty").doc(this.id).delete()
        .then(() => {
            alert("刪除成功!");
            this.$router.push({name: 'Faculty'});
        }).catch((error) => {
            console.log("Error getting document:", error);
        });
      }
    },
    selfUpdate(val) {
      this.data.src = val.src;
      this.data.width = val.width;
      this.data.height = val.height;
      this.data.pic_name = val.pic_name;
    },
    checkVerify(val) {
      if (val) this.verify = true;
      else this.verify = false;
    }
  }
}
</script>

<style scoped>
label{
  cursor: pointer;
}
label span, .remind{
  color:#BE0000
}
</style>


// WEBPACK FOOTER //
// src/components/FacultyInfo.vue